// Copyright (c) Frisbii GmbH. All rights reserved.
"use strict";

const PgLogsWithAcknowledgeController = function ($scope, $http, PgLogsWithAcknowledge) {
    $scope.loading = true;

    $scope.logLevels = [];

    $scope.logs = [];
    
    const getEmptyFilter = function () {
        return {
            Level: '',
            Message: '',
            After: null,
            Before: null,
        };
    };
    const pageSize = 100;

    $scope.filter = getEmptyFilter();

    $scope.loadPage = function () {
        $http.get('/api/v1/paymentGateway/logs/loglevels', {cache: true}).then(function (result) {
            $scope.logLevels = result.data;
        });
    }

    $scope.loadPage();

    $scope.fetchLogs = function () {
        $scope.loading = true;
        $scope.logs = $scope.paginator(function(options, callback) {
                return PgLogsWithAcknowledge.query(options, function()
                {
                    callback();
                    $scope.loading = false;
                });
            },
            $scope.filter,
            pageSize);
    }

    $scope.fetchLogs();

    $scope.resetFilter = function () {
        $scope.filter = getEmptyFilter();
    };

    $scope.acknowledgeByFilter = function () {
        if ($scope.filter.After ===  '' || $scope.filter.After === undefined)
            $scope.filter.After = null;
        if ($scope.filter.Before ===  '' || $scope.filter.Before === undefined)
            $scope.filter.Before = null;
        $scope.filter.Take =  pageSize + 1;
        PgLogsWithAcknowledge.acknowledge($scope.filter);
        setTimeout(function () {
            $scope.fetchLogs();
        }, 200);
    };

    $scope.acknowledgeById = function (logId) {        
        PgLogsWithAcknowledge.acknowledgeById({ id : logId});
        setTimeout(function () {
            $scope.fetchLogs();
        }, 200);
    };
    
};
PgLogsWithAcknowledgeController.$inject = ["$scope", "$http", "PgLogsWithAcknowledge"];
